import { TOGGLE_COMPANY_LIST } from 'actions/actionTypes';
import * as CompanyAction from 'actions/backyard/companyActions';
import { fork, put, take } from 'redux-saga/effects';
import { createLazily } from '../index';

function* runResetCompanySearchKeyword(flag: boolean) {
  if (!flag) {
    yield put(CompanyAction.changeCompanySearchKeyword(''));
  }
}

function* handleResetCompanySearchKeyword() {
  const lazily = createLazily(500);
  while (true) {
    const { flag } = yield take(TOGGLE_COMPANY_LIST);
    yield fork(lazily, runResetCompanySearchKeyword, flag);
  }
}

export default function* uiSaga() {
  yield fork(handleResetCompanySearchKeyword);
}
